import {PROVINCE_CODE_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapClientProvinceCodeToDomainValue = (provinceCode?: string): string | DomainValueReference | null => {
  if (!provinceCode) {
    return null;
  }

  if (!(provinceCode in PROVINCE_CODE_TO_DV_MAPPING)) {
    return provinceCode;
  }

  return {$ref: PROVINCE_CODE_TO_DV_MAPPING[provinceCode as keyof typeof PROVINCE_CODE_TO_DV_MAPPING]};
};
